<template>
  <!-- 购课列表 -->
  <div class="main">
    <div class="invite-list">
      <div class="invite-wrapper">
        <div class="list">
          <div class="buy-item" v-for="(item, index) in buyList" :key="index">
            <div class="top">
              <div class="top-item mobile">
                <div class="top-item-title">手机</div>
                <div class="top-item-text">{{ item.mobile }}</div>
              </div>
              <div class="top-item nick">
                <div class="top-item-title">昵称</div>
                <div class="top-item-text">{{ item.nickName }}</div>
              </div>
              <div class="top-item time">
                <div class="top-item-title">购课时间</div>
                <div class="top-item-text">{{ item.payDate }}</div>
              </div>
            </div>
            <div class="top mar">
              <div class="top-item mobile">
                <div class="top-item-title">购课类型</div>
                <div class="top-item-text">{{ item.periodTypeName }}</div>
              </div>
              <div class="top-item nick">
                <div class="top-item-title">订单总价</div>
                <div class="top-item-text">{{ item.price }}</div>
              </div>
              <div class="top-item time">
                <div class="top-item-title">奖励金</div>
                <div class="top-item-text">{{ item.recommendAmount }}</div>
              </div>
              <div class="top-item num">
                <div class="top-item-title">订单状态</div>
                <div class="top-item-text">{{ item.stateName }}</div>
              </div>
            </div>
          </div>
          <div class="item-footer" v-if="buyList.length">已经到底啦～</div>
          <div class="item-footer" v-else>暂无数据</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBuyUserList } from '../../request/api/recommend'
export default {
  data () {
    return {
      buyList: []
    }
  },
  created () {
    this._getBuyUserList()
  },
  methods: {
    async _getBuyUserList () {
      let { data } = await getBuyUserList({
        userId: this.$route.query.userId,
      })
      console.log(data, 'ddd')
      let recommendList = data || []
      recommendList.forEach(item => {
        item.mobile = item.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
      })
      this.buyList = recommendList
    }
  }
}
</script>

<style scoped lang='less'>
.main {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // display: flex;
  padding: 30px;
  background: #7969fc;
}
.invite-list {
  background: #fff;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  overflow-y: auto;
  border-radius: 16px;
  .head {
    display: flex;
    align-items: center;
    padding: 0 20px;
    .head-item {
      display: flex;
      align-items: center;
      height: 100px;
      text-align: left;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 33px;
      &.mobile {
        width: 279px;
      }
      &.nick {
        width: 230px;
      }
      &.time {
        flex: 1;
      }
    }
  }
  .invite-wrapper {
    flex: 1;
    overflow-y: auto;
    .list {
      .list-item {
        display: flex;
        align-items: center;
        padding: 30px 20px;
        border-bottom: 1px solid #eeeeee;
        .item {
          text-align: left;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222222;
          line-height: 40px;
          &.mobile {
            width: 279px;
          }
          &.nick {
            width: 230px;
          }
          &.time {
            flex: 1;
          }
        }
      }
      .buy-item {
        display: flex;
        flex-direction: column;
        padding: 30px 30px;
        border-bottom: 1px solid #eeeeee;
        .top {
          display: flex;
          align-items: center;
          &.mar {
            margin-top: 32px;
          }
          .top-item {
            text-align: left;
            &.mobile {
              width: 212px;
            }
            &.nick {
              width: 161px;
            }
            &.time {
              width: 161px;
            }
            &.num {
              flex: 1;
              text-align: right;
            }
            .top-item-title {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 33px;
            }
            .top-item-text {
              margin-top: 12px;
              font-size: 28px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #222222;
              line-height: 40px;
            }
          }
        }
      }
      .item-footer {
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #cccccc;
        line-height: 30px;
      }
    }
  }
}
</style>